import { Button, Result } from 'antd';

import { LeadCard } from '@app/components/LeadCard';

import { useLeadCardPage } from '../hooks';

import type { FC } from 'react';

export const LeadCardPage: FC = () => {
  const {
    leadId,
    goBack,
    leads,
    hasNextLeadsPage,
    onLeadClick,
    onLeadUpdated,
    onBackToLeads,
    onLoadNextLeads,
    isLeadsLoading,
    isNextLeadsPageLoading,
  } = useLeadCardPage();

  if (!leadId) {
    return (
      <Result
        status="404"
        title="Карточка лида не найдена"
        subTitle={`Просим прощения, но запрашиваемая карточка лида c ID ${leadId} не существует или была удалена.`}
        extra={
          <Button type="primary" onClick={goBack}>
            Вернуться назад
          </Button>
        }
      />
    );
  }

  return (
    <LeadCard
      leadId={leadId}
      leads={leads}
      showLeadList
      hasNextLeadsPage={hasNextLeadsPage}
      onLeadClick={onLeadClick}
      onLeadUpdated={onLeadUpdated}
      onBackToLeads={onBackToLeads}
      onLoadNextLeads={onLoadNextLeads}
      isLeadsLoading={isLeadsLoading}
      isNextLeadsPageLoading={isNextLeadsPageLoading}
    />
  );
};
